import React from "react";
import PropTypes from "prop-types";

const CollectionItemCard = ({
	imgSrc,
	title,
	subtitle,
	altText,
	setWindowLocationHash,
	itemId,
	setItemId,
	index,
	setModalIsOpen,
	setCurrentModalItemIndex,
}) => {
	const placeholderImgSrc = `${mainScript.assetPath}images/png/placeholder/bmo-portrait-placeholder.png`;

	const values = {
		image: imgSrc ? imgSrc : placeholderImgSrc,
		title: title ? title : "Untitled",
		subtitle: subtitle ? subtitle : "",
		altText: altText ? altText : "",
	};

	const handleOpenModal = () => {
		setWindowLocationHash(null);
		setItemId(itemId);
		setCurrentModalItemIndex(index);
		setModalIsOpen(true);
	};

	return (
		<li>
			<button
				className="single-collection-page__card-button"
				data-modal-item-id={itemId}
				aria-controls={`modal-${itemId}`}
				onClick={handleOpenModal}
				onKeyDown={(event) => {
					if (event.key !== 'Enter') return;
					event.preventDefault();
					handleOpenModal();
				}}
			>
				<div className="aspect-ratio-box">
					<img
						className="single-collection-page__card-img"
						src={values.image}
						alt={values.altText}
					/>
				</div>
				<h3
					className="single-collection-page__card-title"
					dangerouslySetInnerHTML={{ __html: values.title }}
				></h3>
				<p className="single-collection-page__card-subtitle">
					{values.subtitle}
				</p>
			</button>
		</li>
	);
};

export default CollectionItemCard;

CollectionItemCard.propTypes = {
	imgSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	title: PropTypes.string,
	subtitle: PropTypes.string,
	altText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	setWindowLocationHash: PropTypes.func,
	itemId: PropTypes.string,
	setItemId: PropTypes.func,
	index: PropTypes.number,
	setModalIsOpen: PropTypes.func,
	setCurrentModalItemIndex: PropTypes.func,
};
